import {
    BOOKING_CONFIRMATION_EMAIL,
    GOG_INVITE_BC_EMAIL,
} from '../../../../utils/EDAP/Conversation';
import {handleError} from '../../../../utils/handleError';

import URLSearchParams from '@ungap/url-search-params';

const getActionLocation = (actionLocation, history) => {
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const utmContent = params.get('utm_content');
    if (utmContent === GOG_INVITE_BC_EMAIL) {
        return BOOKING_CONFIRMATION_EMAIL;
    }
    return actionLocation;
};

const updateApolloCacheForGuests = (
    store,
    mutationResponse,
    conversationId,
    GuestsOfGuestsQuery
) => {
    try {
        // Fetching the cached conversation query from apollo-client store
        const data = store.readQuery({
            query: GuestsOfGuestsQuery,
            variables: {conversationId},
        });
        // Updating the data w.r.t. mutationResponse
        data.getTravelerStay.stayGuestOfGuests = mutationResponse;
        // Re-writing the store after manipulation.
        store.writeQuery({
            query: GuestsOfGuestsQuery,
            variables: {conversationId},
            data,
        });
    } catch (error) {
        handleError(error);
    }
};

export {updateApolloCacheForGuests, getActionLocation};
